import React from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumb } from 'antd';
import { useUIStore } from '../store/ui-store';
import { UserProfileBadge } from './user-profile-badge';
import { Sprite } from './sprite';

export const Header: React.FC = () => {
  const { title, breadcrumbItems } = useUIStore();

  return (
    <header className="sticky top-0 bg-white" style={{zIndex:2}}>
      <nav className="w-full border-b border-gray-medium">
        <div className="w-full mx-auto py-5 flex flex-row justify-between px-12 py-6">
          <div>
            {breadcrumbItems ? (
              <Breadcrumb separator="<">
                <Breadcrumb.Item>&nbsp;</Breadcrumb.Item>
                {breadcrumbItems.map(item => (
                  <Breadcrumb.Item key={item.label}>
                    <Link to={item.link}>
                      <div className="text-blue">{item.label}</div>
                    </Link>
                  </Breadcrumb.Item>
                ))}
              </Breadcrumb>
            ) : (
              ''
            )}
            <h1 className="text-[2rem] font-bold">{title}</h1>
          </div>
          <div className="flex flex-row">
            <div className="flex flex-col justify-center pl-12">
              <button type="button">
                <UserProfileBadge />
              </button>
            </div>
            <div className="flex flex-col justify-center pl-1">
              <button type="button">
                <Sprite
                  name="icon-caret"
                  className="fill-gray text-gray hover:fill-blue hover:text-blue w-[24px] h-[24px] transition duration-150"
                />
              </button>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};
